'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emitComponentEvent = emitComponentEvent;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function emitComponentEvent(id, type, detail) {
  var el = document.querySelector('[data-id="' + id + '"]');

  if (_lodash2.default.isElement(el)) {
    var e = new CustomEvent(type, {
      bubbles: true,
      detail: detail
    });
    el.dispatchEvent(e);
    return e;
  }

  return null;
}

exports.default = {
  emitComponentEvent: emitComponentEvent
};